
export const environment = {
  production: false,
  name: "QA",

  auth0: {
    domain: 'transnetyx-qa.us.auth0.com',
    clientId: 'wyLe3B5BtGZ6vadtZD2O2e69zvifVtDJ',
    audience: 'Ops_Instrudex_API',
    scope: '',
    redirectUri: `https://instrudex-qa.transnetyx.com`
  },

  apiUrl: "https://api-qa.transnetyx.com/instrudex/"
};
